import { render } from "./LockCard.vue?vue&type=template&id=98c5186a&scoped=true"
import script from "./LockCard.vue?vue&type=script&lang=js"
export * from "./LockCard.vue?vue&type=script&lang=js"

import "./LockCard.vue?vue&type=style&index=0&id=98c5186a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c5186a"]])

export default __exports__